import { useEffect, useState } from 'react';
export { orderingPausedHandle as handle } from '../routeMetadata';
import { Link } from 'react-router';
import { supabase } from '../utils/supabaseClient';

const SYSTEM_SETTINGS_ID = '00000000-0000-0000-0000-000000000001';

const DEFAULT_MESSAGE =
  "We're currently reorganizing a few things — ordering has temporarily been disabled. " +
  'Please check back later to place an order. We appreciate your patience and ' +
  "can't wait to help you in the very near future.";

export default function OrderingPaused() {
  // The custom message is read client-side after mount. SSR shows the default
  // copy so the page is still useful with JS disabled / before hydration.
  const [message, setMessage] = useState<string>(DEFAULT_MESSAGE);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('system_settings')
      .select('ordering_disabled_message')
      .eq('id', SYSTEM_SETTINGS_ID)
      .single()
      .then(({ data }) => {
        if (cancelled) return;
        const custom = (data as { ordering_disabled_message?: string | null } | null)
          ?.ordering_disabled_message;
        if (custom && custom.trim().length > 0) {
          setMessage(custom);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex items-center justify-center px-4 py-16 sm:py-24">
      <div className="max-w-xl w-full text-center">
        <div className="mx-auto mb-6 inline-flex items-center justify-center w-14 h-14 rounded-full bg-yellow-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className="w-7 h-7 text-yellow-700"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2" />
            <circle cx="12" cy="12" r="9" />
          </svg>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">
          Ordering is temporarily paused
        </h1>
        <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
          {message}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/bidets"
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Browse our bidets
          </Link>
          <Link
            to="/questions"
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            Read our FAQ
          </Link>
        </div>
        <p className="mt-10 text-xs text-gray-400">
          Have an existing order or question? Reach us at{' '}
          <a href="mailto:hello@bidetny.com" className="underline">
            hello@bidetny.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
